import { useTranslation } from 'react-i18next';
import { AdsChunkSize } from './AdsWithInfiniteScroll.types';
import { AdsSection } from '@/components/AdsSection/AdsSection';
import { ROUTES } from '@/constants/routes';
import type { AdsSectionLayoutScope } from '@/components/AdsSection/AdsSection.types';
import type { SearchResultsSections } from '@/components/SearchResults';

interface VipAndLatestAdsSkeletonLoaderProps {
  layoutScope?: AdsSectionLayoutScope;
  sections?: SearchResultsSections;
}

const DEFAULT_SECTIONS = { vipAds: true, latestAds: true };

export const VipAndLatestAdsSkeletonLoader = (
  {
    layoutScope,
    sections = DEFAULT_SECTIONS,
  }: VipAndLatestAdsSkeletonLoaderProps = {
    sections: DEFAULT_SECTIONS,
  }
) => {
  const { t } = useTranslation();

  return (
    <>
      {sections.vipAds && (
        <AdsSection
          title={sections.latestAds ? t('pages.home.vip_ads') : undefined}
          adsLoading
          hasPaddingTop
          chunkSize={
            sections.vipAds && sections.latestAds
              ? AdsChunkSize.Small
              : AdsChunkSize.Middle
          }
          allAdsLinkData={sections.latestAds ? { href: ROUTES.ad } : undefined}
          layoutScope={layoutScope}
        />
      )}
      {sections.latestAds && (
        <AdsSection
          title={t('pages.ads.ads')}
          adsLoading
          chunkSize={AdsChunkSize.Middle}
          layoutScope={layoutScope}
        />
      )}
    </>
  );
};
